import { TranslationOptions } from './types';

export enum OptimusTextKey {
    DialogedDatePickerCancel = 'DialogedDatePickerCancel',
    TableClearFilters = 'TableClearFilters',
    TableFilterBySearch = 'TableFilterBySearch',
    TableFilterContains = 'TableFilterContains',
    TableFilterGreaterThan = 'TableFilterGreaterThan',
    TableHeaderSearch = 'TableHeaderSearch',
    TablePaginationShow = 'TablePaginationInfoShow',
    TablePaginationItemsCount = 'TablePaginationItemsCount',
    TablePaginationSizeItemsCount = 'TablePaginationSizeItemsCount',
    TableSortAscending = 'TableSortAscending',
    TableSortDescending = 'TableSortDescending',
}

export const defaultTranslations = {
    [OptimusTextKey.DialogedDatePickerCancel]: 'Cancel',
    [OptimusTextKey.TableClearFilters]: 'Clear filters',
    [OptimusTextKey.TableFilterBySearch]: 'Filter by search',
    [OptimusTextKey.TableFilterContains]: 'Contains',
    [OptimusTextKey.TableFilterGreaterThan]: 'Greater than',
    [OptimusTextKey.TableHeaderSearch]: 'Search',
    [OptimusTextKey.TablePaginationShow]: 'Show',
    [OptimusTextKey.TablePaginationItemsCount]: ({ items }: TranslationOptions) =>
        `${items} ${items !== '1' ? 'items' : 'item'}`,
    [OptimusTextKey.TablePaginationSizeItemsCount]: ({ items }: TranslationOptions) => `of ${items} items`,
    [OptimusTextKey.TableSortAscending]: 'Sort ascending',
    [OptimusTextKey.TableSortDescending]: 'Sort descending',
};
